import React, { useEffect, useLayoutEffect,useState, useRef } from "react";
import h5Share from '@/utils/h5Share'
import styled from "styled-components";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
// import Tabs from '@/components/Tabs'
import styles from '@/styles'

import { handleUploadTrace } from '../activity_30/stock';
import { Tabs } from "antd-mobile";


// import bridge from '@/config/JSbridge'
// 
import { connect } from 'react-redux';

import { jumpTo, userBehaver } from "@/utils";
import OpenApp from '@/components/OpenApp';
import bg0 from './images/0.png';
import bg1 from './images/1.png';
import bg2 from './images/2.png';
// import { Tabs } from 'antd-mobile';
// import {Tabs, Modal} from 'antd-mobile'
// import { Tabs, WhiteSpace } from 'antd-mobile';


export const isStorm = bwmodel.app === 'storm';

 const activeIdKey_208 = (window.localStorage.getItem('activeIdKey_208'))||0;
  
const CarnivalGame = ({token}) => {

  
  const bodyContainer = useRef()
  const [initialPage, setInitialPage] = useState(Number(activeIdKey_208))
  // const [rankData, setRankData] = useState({


  const initPage = () => {
    
    
      
  }

 

  function handleScroll(e) {
    let footer = document.getElementById('footer');
    if(footer) {
      if(window.scrollY >=20) {
        footer.classList.add('footer-freeclass-block');
      }else {
        footer.classList.remove('footer-freeclass-block');
      }
    }
   
  }
  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
}, [])

  useLayoutEffect(() => {
    // if (token  || process.env.REACT_APP_ENV === 'development') {
   
    // }
    console.log('initPage');
    
    initPage()

  
  }, [token]);


  useEffect(() => {
    console.log('xxxx');
    
    h5Share.main({ 
      title: `【炒股必看】牛市炒股第一站`,
      desc: '专业的股票研究投资平台，你想要的都在这里～',
      link: process.env.REACT_APP_DEMAND_URL + 'active_190',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo9.jpg',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo9.jpg'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo9.jpg'
      }
    })

    // 埋点
    if (isStorm) {
      handleUploadTrace('7th-anniversary', 'visitor')
    } else {
      handleUploadTrace('7th-anniversary_outside', 'visitor')
    }
    //
    
  }, [])



  function hanleClickLink(row) {
  
   
    const {link, activeIdKey } = row;
     userBehaver({
        activeIdKey: activeIdKey,
   
        time: new Date()
  
      });

      jumpTo(link);
  }

  function onChangeTab(index) {
    const obj = {
      0: 'SelectPage',
      1: 'CheckPage',
      2: 'KnowledgePage',
      3: 'TrainingPage',
    }
    setInitialPage(index)
    window.localStorage.setItem('activeIdKey_208', index);
     userBehaver({
        activeIdKey: obj[index],
        time: new Date()
      });

  }
 
 // Tab配置
 const tabs = [
    { title: '选股' },
    { title: '查股' },
    { title: '学知识' },
    { title: '练炒股' }
  ];
  const card1Data = [[
    {
      title: '今日热点资讯',
      link: 'storm://app/userzone?userID=999',
      activeIdKey: 'SelectPage_Today_HotMarket',
    },
     {
      title: '今日热点概念股一览',
      link: 'storm://app/topic/detail?topicId=166cd3e0763b4dddbea0fef8088173ae',
      activeIdKey: 'SelectPage_Today_PopularConcepts',
    },
     {
      title: '当前热门题材概念股',
      link: 'storm://app/userzone?userID=27feaddee4b84ed9964ab1c48e12fb03',
      activeIdKey: 'SelectPage_Today_PopularThemes',
     
    },
  ],
    [
      {
        title: '条件选股',
        img: require('./images/评级.png'),
        link: 'storm://app/marketQuotations/stockPicker',
        activeIdKey: 'SelectPage_one_Condition',
        stock: '600***'
      },
      {
        title: 'AI选股',
        img: require('@/img/activity_100/img1@2x.png'),
        link: 'https://f10.wogoo.com/#/answers/stock',
        activeIdKey: 'SelectPage_one_AI',
         stock: '000***'
      },
       {
        title: '形态选股',
        img: require('@/img/activity_100/img1@2x.png'),
        link: 'storm://app/marketQuotations/patternStockList',
        activeIdKey: 'SelectPage_one_Form',
         stock: '300***'
      },
       {
        title: '产业链选股',
        img: require('@/img/activity_100/img1@2x.png'),
        link: 'storm://app/marketQuotations/industryChainPre',
        activeIdKey: 'SelectPage_one_Industry',
         stock: '600***'
      },
       {
        title: 'VIP指标选股',
        img: require('@/img/activity_100/img1@2x.png'),
        link: 'storm://app/marketQuotations/wogooReplay',
        activeIdKey: 'SelectPage_one_VIPIndicators',
         stock: '600***'
      },
       {
        title: '牛散持仓',
        img: require('@/img/activity_100/img1@2x.png'),
        link: 'storm://app/marketQuotations/shareHolderMain',
        activeIdKey: 'SelectPage_one_NiuSan',
         stock: '000***'
      },  {
        title: '热点挖掘选股',
        img: require('@/img/activity_100/img1@2x.png'),
        link: 'https://f10.wogoo.com/#/spu-article',
        activeIdKey: 'SelectPage_one_HotspotMining',
         stock: '600***'
      }, {
        title: '研报选股',
        img: require('@/img/activity_100/img1@2x.png'),
        link: 'storm://app/specialColumn',
        activeIdKey: 'SelectPage_one_Research',
         stock: '300***'
      },
    ]
  ]
  const card3Data = [
    
    [
      {
        title: '短线选手入门',
        tips: '快速了解短线炒股干货知识',
        img: require('./images/摄图网_1.png'),
        link: 'storm://app/topic/detail?topicId=58eb3f84a68f41b49dd5a71679d20a2f',
        activeIdKey: 'KnowledgePage_learn_ShortTermEntry',
      },
       {
        title: '牛市生存手册',
        tips: '让你在市场上更好的存活',
        img: require('./images/摄图网_2.png'),
        link: 'https://www.wogoo.com/essay/#/community?momentsId=40798470a66045099a2bf26458abbd5b',
        activeIdKey: 'KnowledgePage_learn_BullMarket',
      }, {
        title: '投资基础知识',
        tips: '快速了解股票K线',
        img: require('./images/摄图网_3.png'),
        link: 'https://www.wogoo.com/essay/#/?articleId=fb6b0cce28594b26a25c44d2f9586c6f&articleType=1',
        activeIdKey: 'KnowledgePage_learn_knowledge',
      },
    ],
    [
      {
        title: '实盘高手挑战赛',
        tips: '看高手每天持仓交易情况',
        img: require('./images/摄图网_4.png'),
        link: 'https://f10.wogoo.com/#/stock-trading',
        activeIdKey: 'KnowledgePage_Look_RealGame',
      },
      {
        title: '高手组合排行榜',
        tips: '看高手股票组合',
        img: require('./images/摄图网_5.png'),
        link: 'storm://app/combine/marketSectionRankingDetail',
        activeIdKey: 'KnowledgePage_Look_Combination',
      },
    ],
    [{
      title: '市场盘面复盘',
      tips: '了解市场数据运动情况',
      img: require('./images/摄图网_6.png'),
      link: 'storm://app/userzone?userID=354eefb37f444ba6a4b9c9af8080aef4',
      activeIdKey: 'KnowledgePage_Review_MarketReview',
    
    },
    {
      title: '涨停复盘',
      tips: '一图了解所有涨停股情况',
      img: require('./images/摄图网_7.png'),
      link: 'storm://app/topic/detail?topicId=efa56650cd9d45ecb067d4f3c960638f',
      activeIdKey: 'KnowledgePage_Review_LimitUp',
    
    }]  
  ]
  const card2Data = [
    {
      title: '查评级',
      tips: '基于市值风云评分模型',
      tips1: '市场排名<span>1803<span>名',
      img: require('./images/评级.png'),
      stock: '600***',
      link: 'storm://app/wogooRating/home',
      activeIdKey: 'CheckPage_Grade',
    },
    {
      title: '查风险',
      tips: '股票触发证监会规则情况',
      tips1: '<span>1</span>个低风险',
       img: require('./images/风险.png'),
      stock: '300***',
      link: 'storm://app/marketQuotations/riskRadar?index=1&isAppNeedLogin=1',
       activeIdKey: 'CheckPage_Fengxian',
    },
    {
      title: '看AI解读财报',
      tips: 'AI解读公司基本面',
      tips1: '小家电、厨具电器公司…',
      img: require('./images/ai.png'),
      link: 'https://f10.wogoo.com/#/answers/stock',
       activeIdKey: 'CheckPage_AI',
      
    },
  ]

  const card4Data = [
    {
      img: require('./images/card4_0@2x.png'),
      link: 'storm://app/marketQuotations/klineCamp',
      activeIdKey: 'TrainingPage_TradingCamp',
    },
    {
      img: require('./images/card4_1@2x.png'),
      link: 'storm://app/user/combinationList',
      activeIdKey: 'TrainingPage_SimulatedCombination',
    },
    {
      img: require('./images/card4_2@2x.png'),
      link: 'https://www.wogoo.com/activity/active_171',
      activeIdKey: 'TrainingPage_Open',
    },
  ]
  return <div>
     {isStorm && 
        <Header
          title="【炒股必看】牛市炒股第一站"
          right={
                  <div 
                    onClick={()=> {
                      jumpTo('https://m.wogoo.com/serviceCode');
                    }}
                    className="title_right"
                  >
                    
                  {bwmodel.theme === '0' ?      <img src={require('./images/kefu2.png')} alt='' />:   <img src={require('./images/kefu.png')} alt='' />} 
                        
                    </div>
                }
          src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
          bg_color={styles.bg_color2}
          
        />
      }     
     
  
  <Container style={isStorm ? {top:'44px'} : {top: '0px'}} ref={bodyContainer}>
    {/* page={initialPage} */}
    
    {

     <Tabs 
        tabs={tabs}
      initialPage={initialPage}
        onTabClick={(tab, index) => { onChangeTab(index);  }}
     
        // 2.0版本的关键优化参数
   // 只渲染当前标签，减少DOM数量
    
        onChange={(tab, index) => { console.log('onChange', index, tab); }}
    >
      {/* <div style={{ height: 100, background: '#fff' }}>
        1
      </div>
      <div style={{ height: 100, background: '#99FF00' }}>
        2
      </div>
       <div style={{ height: 100, background: '#fff' }}>
        3
      </div>
      <div style={{ height: 100, background: '#99FF00' }}>
        5
      </div> */}
      <TabsItem >
        <div className="title">
         <img src={require('./images/今天炒什么@2x.png')} alt=""/></div>
        <NewsBox>
          {
            card1Data[0].map((item, index) => (
              <div className="news" onClick={() =>(hanleClickLink(item))}>
                 <p className="">{item.title}</p>
                  <img src={require('./images/arrow.png')}  alt="" />
              </div>
             
            ))
          }
        </NewsBox>
         <div className="title">
             <img src={require('./images/一键选牛股@2x.png')} alt=""/></div>
   
        <Card1 className="card_stocks">
          {
            card1Data[1].map((it, index) => (
              <div className="card_stock" key={index} onClick={() => hanleClickLink(it)}>
                
                <div className="card_stock_title" >
                    {it.title} 
                   <img src={require('./images/arrow.png')}  alt="" />
                </div>
                <div className="card_stock_bottom">
                  <div className="card_stock_name glass-hover">{it.stock}</div>
                  <div className="price">+10.01%</div>
                </div>
              </div>
            ))
          }
        </Card1>
      </TabsItem>
      <TabsItem >
         <div className="title">
          <img src={require('./images/买股之前搜一搜@2x.png')} alt=""/></div>
         {
          card2Data.map((it, index) => (
            <div className="card2" onClick={() =>(hanleClickLink(it))}> 
            <div className="card_left">
              <div className="card_title">{it.title}</div>
              <div className="card_tips">{it.tips}</div>
              <div className="card_bottom">
                <span className="tag">示例</span>
                { it.stock &&   <span className="glass-hover">{it.stock}</span>}
              
                <span className="card_tips1" dangerouslySetInnerHTML={{ __html: it.tips1 }}></span>
              </div>
            </div>
            <div className="card_right">
              <img src={it.img} alt=""/>  
            </div>
         </div>
          ))
         }
         
      </TabsItem>
      <TabsItem >
        <div className="title">
          <img src={require('./images/学投资知识@2x.png')} alt=""/>
        </div>
 
        {
          card3Data[0].map((it, index) => (
            <Card3 onClick={() =>(hanleClickLink(it))}>
              <div className="card_left"> 
                <div className="card_left_title">{it.title}</div>
                <div className="card_left_tips">{it.tips}</div>
              </div>
              <div className="card_right">
                <img src={it.img} alt=""/>  
              </div>
            </Card3>
          ))
        }
        
        <div className="title"> <img src={require('./images/看牛人操作@2x.png')} alt=""/></div>
        {
          card3Data[1].map((it, index) => (
            <Card3 onClick={() =>(hanleClickLink(it))}>
              <div className="card_left"> 
                <div className="card_left_title">{it.title}</div>
                <div className="card_left_tips">{it.tips}</div>
              </div>
              <div className="card_right">
                <img src={it.img} alt=""/>  
              </div>
            </Card3>
          ))
        }
            <div className="title"> <img src={require('./images/每日复盘@2x.png')} alt=""/></div>
        {
          card3Data[2].map((it, index) => (
            <Card3 onClick={() =>(hanleClickLink(it))}>
              <div className="card_left"> 
                <div className="card_left_title">{it.title}</div>
                <div className="card_left_tips">{it.tips}</div>
              </div>
              <div className="card_right">
                <img src={it.img} alt=""/>  
              </div>
            </Card3>
          ))
        }
      </TabsItem>
      <TabsItem >
        <div className="title"  >
          <img src={require('./images/交易训练营@2x.png')} alt=""/>
        </div>
        <div onClick={() =>(hanleClickLink(card4Data[0]))}>
          <img src={card4Data[0].img} alt=""/>
        </div>
        <div className="title">
           <img src={require('./images/模拟组合@2x.png')} alt=""/>
          </div>
         <div onClick={() =>(hanleClickLink(card4Data[1]))}>
          <img src={card4Data[1].img} alt=""/>
        </div>
        <div className="title">
          <img src={require('./images/炒股第一步 先开户@2x.png')} alt=""/></div>
         <div onClick={() =>(hanleClickLink(card4Data[2]))}>
          <img src={card4Data[2].img} alt=""/>
        </div>
      </TabsItem> 
    </Tabs>
    } 
{/* 
    <Tabs tabs={tabs}
       initialPage={initialPage}
      onChange={(tab, index) => { console.log('onChange', index, tab); }}
       onTabClick={(tab, index) => { onChangeTab(index);  }}
    >
       <div style={{ height: 100, background: '#fff' }}>
        ---
      </div>
      <div style={{ height: 100, background: '#99FF00' }}>
        2
      </div>
       <div style={{ height: 100, background: '#fff' }}>
        3
      </div>
      <div style={{ height: 100, background: '#99FF00' }}>
        5
      </div>
    </Tabs> */}

      {
            !isStorm && 
            <div>
              <OpenApp bottom='bottom'></OpenApp>
            </div>
           }
   </Container>
  </div>
  ;
}

const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(CarnivalGame))

const TabsItem = styled.div`
  margin:0 16px;
  font-size: 14px;
  color: #333;
  box-size: border-box;
  overflow: hidden;
`;
const Container = styled.div`
/* 为2.0版本的Tabs容器添加优化 */
.am-tabs-default-bar {
  -webkit-overflow-scrolling: touch; /* iOS平滑滚动 */
  will-change: transform;
}

.am-tabs-content-wrap {
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  /* 启用GPU加速 */
  -webkit-transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
}

/* 禁用部分动画效果 */
.am-tabs-tabpane {
  animation-duration: 200ms !important;
  transition: transform 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1;
  background: #F3F4F9;
 
  .am-tabs-default-bar-tab {
    color: #9696A6;
    font-weight: normal;
  }
  .am-tabs-default-bar-tab-active  {
    color: #293241;
    
  }
  .am-tabs-default-bar-underline {
    width: 20px !important;
    margin-left: calc(12.5% - 10px);
    border-color: #FF2848;
  }
  img {
    max-width: 100%;
  }
  .title {
    font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
    font-weight: bold;
    font-size: 18px;
    color: #293241;
    line-height: 25px;
    text-align: left;
    font-style: normal;
    margin-top: 20px;
    margin-bottom: 12px;
    img {
      height: 18px;
    }
    
  }
  .card2 {
    display: flex;
    height: 112px;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 16px;
    margin-top: 12px;
    .card_left {
      flex: 1;
      .card_title {
        font-weight: 500;
        font-size: 18px;
        color: #293241;
        line-height: 25px;
      }
      .card_tips {
        font-size: 14px;
        color: #9696A6;
        line-height: 20px;
        margin-top: 2px;
        margin-bottom:10px;
      }
      .tag {
        width: 28px;
        height: 14px;
        background: linear-gradient( 180deg, #FFB3BE 0%, #FF5F77 100%);
        border-radius: 3px;
        display: inline-block;
        font-size: 10px;
        text-align: center;
        line-height: 14px;
        color: #FFFFFF;
        margin-right: 5px;
      }
      .glass-hover {
       font-size: 12px;
        // display: inline-block;
        // background: rgba(255, 255, 255, 0.1);
        // filter: blur(4px);
        // transition: all 0.3s ease;
      }
      .card_tips1 {
        margin-left: 5px;
        font-size: 12px;
        span {
           color: #FF2848;
        }
      }
      .card_bottom {
        padding: 4px;
        display: inline-block;
        background: #F7F9FD;
        border-radius: 5px;
      }
   }
    .card_right { 
      width: 72px;
      height: 72px;
      img {
        width: 72px;
        height: 72px;
      }
  
  }

 
`;

const Card3 = styled.div` 
  display: flex;
  padding: 14px 16px;
  background: #FFFFFF;
  border-radius: 16px;
  margin: 12px 0;
  .card_left { 
    flex: 1;
    
  }
  .card_left_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #293241;
    line-height: 35px;
  }
    .card_left_tips {
      font-family: PingFangSC, PingFang SC;
     font-weight: 400;
      font-size: 14px;
      color: #9696A6;
      line-height: 28px;
    }
  
    .card_right { 
      width: 104px;
height: 64px;
      img {
        width: 104px;
height: 64px;
      }
    }
`;

const Card1 = styled.div` 
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 12px;
    margin-top: 13px;
    .card_stock {
      padding: 12px;
      background: #FFFFFF;
      border-radius: 16px;
    }
    .card_stock_title, .card_stock_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .card_stock_title {
      font-size: 16px;
      color: #293241;
      line-height: 22px;
      margin-bottom: 5px;
      font-weight: 600;
    }
    .glass-hover {
        font-size: 14px;
        color: #293241;
        // display: inline-block;
        // background: rgba(255, 255, 255, 0.1);
        // filter: blur(4px);
        // transition: all 0.3s ease;
      }
      .price {
        font-weight: 400;
        font-size: 14px;
        color: #FF2848;
        line-height: 20px;
      }
`;

const NewsBox = styled.div` 
background: #FFFFFF;
border-radius: 12px;
 padding: 0 13px;
 margin: 13px 0;
 .news {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #293241;
    line-height: 22px;
    text-align: left;

    background-repeat: no-repeat;
    background-size: 18px 18px;
    padding-left: 23px;
    background-position: 0  50%;
    &:nth-child(1) {
      border-bottom: 1px dashed #E5E5E5;
      background-image: url(${bg0});
    }
    &:nth-child(2) {
     border-bottom: 1px dashed #E5E5E5;
      background-image: url(${bg1});
    }
    &:nth-child(3) {
    background-image: url(${bg2});
    }
    img {
      // height: 18px;
    }
  }

`;


// WEBPACK FOOTER //
// ./src/views/activity_208/index.js